// extracted by mini-css-extract-plugin
export default {"final__wrapper":"style_final__wrapper__14LiB","final__content":"style_final__content__abset","final__img":"style_final__img__WNFER","final__bottom":"style_final__bottom__B5I6Y"};